
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {TakipEntity} from "@/entity/TakipEntity";
import {BankaHesabiSahibiLabel} from "@/enum/BankaHesabiSahibi";

import TakipTalebiGenerator from "@/classes/evrak/TakipTalebi/TakipTalebiGenerator";
import FormWrapper from "@/components/FormWrapper.vue";
import Evrak from "@/classes/evrak/Evrak";
import {AlacakKalemiAlani} from "@/enum/AlacakKalemiAlani";
import {TakipYolu} from "@/enum/TakipYolu";
import {TakipTipi} from "@/enum/TakipTipi";
import {TakipDurumu} from "@/enum/TakipDurumu";

@Component({
  components: {FormWrapper},
})
export default class TakipTalebiTaslak extends Vue {
  @Prop() takip!: TakipEntity;
  @Prop() isKartNoVisible!: boolean;

  ttEvrak: Evrak = new Evrak();
  bankaHesabiSahibiLabel = BankaHesabiSahibiLabel;
  alacakKalemiAlani = AlacakKalemiAlani;
  takipYolu = TakipYolu
  TakipTipi = TakipTipi
  TakipDurumu = TakipDurumu
  isLoadingEvrakData: boolean = false;

  async mounted() {
    // Takip durumuna göre hangi store kullanılacağına karar ver
    const isAcilmamis = this.takip?.takip_durumu === this.TakipDurumu.acilmamis;

    // İlgili store'dan borçlu verilerini al
    const borclular = isAcilmamis
      ? this.$store.state.takipEkle?.takipBorclular?.data
      : this.$store.state.takipDetay?.takip?.borclular;

    if (borclular && Array.isArray(borclular) && borclular.length > 0) {
      this.isLoadingEvrakData = true;

      // Takip durumuna göre ilgili store'un action'ını çağır
      const storeName = isAcilmamis ? 'takipEkle' : 'takipDetay';
      await this.$store.dispatch(`${storeName}/loadBorcluVekillerVeTebligatlar`, borclular);

      // State'deki güncel borçlu verilerini takip objesine merge et
      this.mergeBorcluDataFromState();

      this.isLoadingEvrakData = false;
    }

    if (this.takip) {
      this.onTakipChange();
    }
    // if(this.ttEvrak.TakipYoluData[0] === "İhtiyati Haciz - Haciz"){
    //   this.ttEvrak.IlamData[0] += "<span> ihtiyati haciz kararı</span>";
    // } else {
    //   this.ttEvrak.IlamData[0] += "<span>ilamı</span>";
    // }

  }

  mergeBorcluDataFromState() {
    // Takip durumuna göre hangi store'dan veri çekileceğine karar ver
    const isAcilmamis = this.takip?.takip_durumu === TakipDurumu.acilmamis;

    // İlgili store'dan güncellenmiş borçlu verilerini al
    const stateBorclular = isAcilmamis
      ? this.$store.state.takipEkle?.takipBorclular?.data
      : this.$store.state.takipDetay?.takip?.borclular;

    if (!stateBorclular || !this.takip?.borclular) return;

    this.takip.borclular.forEach((takipBorclu: any) => {
      const stateBorclu = stateBorclular.find((sb: any) => sb.id === takipBorclu.id);
      if (stateBorclu) {
        // State'deki yeni field'ları takip objesindeki borçluya ekle
        takipBorclu.vekiller = stateBorclu.vekiller || [];
        takipBorclu.tebligatlar = stateBorclu.tebligatlar || [];
        takipBorclu.borclu_bilgileri = stateBorclu.borclu_bilgileri || null;
        takipBorclu.adresler = stateBorclu.adresler || [];
        takipBorclu.varsayilan_adres = stateBorclu.varsayilan_adres || null;
      }
    });
  }

  @Watch('isKartNoVisible')
  changeKartNoVisible(){
    if (!this.isKartNoVisible) {
      this.ttEvrak.kartNo = ""
    }else{
      this.ttEvrak.kartNo = this.takip.id.toString()
    }
  }

  @Watch("takip")
  onTakipChange() {
    let takipTalebiGenerator = new TakipTalebiGenerator()
    takipTalebiGenerator.setTakip(this.takip);
    this.ttEvrak = takipTalebiGenerator.getTakipTalebiEvrak();
  }

  imzasizUdfIndir(){
    // Takip talebi tek parça bir tablo; UYAP editörü bir sayfadan uzun tabloyu
    // sayfa-2'ye itip 1. sayfayı boş bıraktığından satır-satır böldürülür.
    this.$helper.getUdfFromComponent("takipTalebi",true,this.takip.id + "_takip_talebi", { splitLayoutTables: true });
  }

  imzaliUdfIndir(){
    this.$helper.getImzaliUdfFromComponent("takipTalebi",true,this.takip.id + "_imzali_takip_talebi", { splitLayoutTables: true });
  }

  print() {
    this.$helper.printComponent('takipTalebi');
  }
}
